const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Name field shouldn’t be empty';
  } else if (values.name?.length > 255) {
    errors.name = 'Name field cannot exceed 255 characters in length';
  }

  if (!values.domain) {
    errors.domain = 'Domain field shouldn’t be empty';
  } else if (values.domain?.length > 253) {
    errors.domain = 'Domain field cannot exceed 253 characters in length';
  }

  return errors;
};

export default validate;
